import dayjs from 'dayjs'
export const setDynamicText = (dateArray, presetText) => {
  const [startStr, endStr] = dateArray;
  const today = new Date(new Date().Format('end'));
  const startDate = new Date(startStr);
  const endDate = new Date(new Date(endStr).Format('end'));
  const start = Math.floor((today.getTime() - startDate.getTime()) / 86400000);
  const end = Math.floor((today.getTime() - endDate.getTime()) / 86400000);

  // 上月验证
  let isLastMonth = false
  let fullYear = today.getMonth() ? today.getFullYear() : today.getFullYear() - 1 // 上月年份
  let lastMonth = today.getMonth() || 12
  if (lastMonth < 10) lastMonth = '0' + lastMonth

  let lastMonthStart = new Date(`${fullYear}-${lastMonth}-01 00:00:00`).getTime()
  let lastMonthEnd = new Date(new Date(fullYear, lastMonth, 0).Format('end')).getTime()
  if (startDate.getTime() === lastMonthStart && endDate.getTime() === lastMonthEnd) isLastMonth = true

  // 去年验证
  let isLastYear = false
  let lastYearStart = new Date(`${today.getFullYear() - 1}-01-01 00:00:00`).getTime()
  let lastYearEnd = new Date(new Date(today.getFullYear() - 1, 12, 0).Format('end')).getTime()
  if (startDate.getTime() === lastYearStart && endDate.getTime() === lastYearEnd) isLastYear = true
  // console.log(12312312321, 'start----')

  if (end <= 0) {
    if (start === 0) {
      return presetText || '今天';
    } else {
      const startWeek = dayjs().startOf('week')
      const endWeek = dayjs().endOf('week')
      const startMonth = dayjs().startOf('month')
      const endMonth = dayjs().endOf('month')

      const now = dayjs()

      const thisMonday = now.startOf('week')    // 本周周一 00:00:00
      const thisSunday = now.endOf('week')      // 本周周日 23:59:59

      const monthStart = now.startOf('month')  // 本月1日 00:00:00
      const monthEnd = now.endOf('month')    // 本月最后一天 23:59:59

      const yearStart = now.startOf('year')   // 本年1月1日 00:00:00
      const yearEnd = now.endOf('year')     // 本年12月31日 23:59:59

      if (
        dayjs(startDate).startOf('day').isSame(thisMonday, 'day') &&
        dayjs(endDate).endOf('day').isSame(thisSunday, 'day')
      ) {
        return presetText || '本周';
      } else if (
        dayjs(startDate).startOf('day').isSame(monthStart) &&
        dayjs(endDate).endOf('day').isSame(monthEnd)
      ) {
        return presetText || '本月';
      } else if (
        dayjs(startDate).startOf('day').isSame(yearStart) &&
        dayjs(endDate).endOf('day').isSame(yearEnd)
      ) {
        return presetText || '今年'
      } else {
        return '最近' + (start + 1) + '天';
      }
    }
  } else if (end === 1) {
    if (start === 1) {
      return '昨天';
    } else {
      return presetText || '过去' + start + '天';
    }
  } else {
    if (startDate.getDay() === 1 && endDate.getDay() === 0 && end <= 7) {
      return presetText || '上周'
    } else if (isLastMonth) {
      return presetText || '上月'
    } else if (isLastYear) {
      return presetText || '去年'
    } else {
      return '过去' + start + '天 至 过去' + end + '天';
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/my-components/custom-date-picker/tools/top-tabs/dynamic-text.js